export default "__VITE_ASSET__c980bb32__"